import React from 'react'
import styled from 'styled-components'

interface ProgressBarProps {
  totalCompetences: number
  completedCompetences: number
  title: string
}

const ProgressBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  // margin-bottom: 32px;
  background-color: #eff3fa;
  padding: 40px;
`

const ProgressBarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Title = styled.h1`
  font-size: 32px;
  font-weight: 400;
  color: #333;
  margin: 0;
`

const CompetenceCount = styled.span`
  font-size: 14px;
  color: #666;
  margin: 0;
`

const ProgressBarTrack = styled.div`
  width: 100%;
  height: 8px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
`

const ProgressBarFill = styled.div<{ progress: number }>`
  height: 100%;
  background: linear-gradient(90deg, #c6016b 0%, #c6016b 100%);
  width: ${(props) => props.progress}%;
  transition: width 0.3s ease-in-out;
  border-radius: 4px;
`

const ProgressBar: React.FC<ProgressBarProps> = ({ totalCompetences, completedCompetences, title }) => {
  const progress = (completedCompetences / totalCompetences) * 100

  return (
    <ProgressBarContainer>
      <ProgressBarHeader>
        <Title>{title}</Title>
      </ProgressBarHeader>
      <CompetenceCount>
        {completedCompetences} de {totalCompetences} competencias a evaluar
      </CompetenceCount>
      <ProgressBarTrack>
        <ProgressBarFill progress={progress} />
      </ProgressBarTrack>
    </ProgressBarContainer>
  )
}

export default ProgressBar
